import { alpha, darken } from '@mui/material/styles/index.js';

/* Common colors as defined in both the light and dark palette designs */
export var WHITE = '#ffffff';
export var ACCENT = {
  300: alpha('#A2B300', 0.5),
  500: '#A2B300',
  700: alpha('#A2B300', 0.9)
};
export var TEAL = {
  50: '#E6F5F7',
  100: '#99D8E0',
  300: '#4DBAC8',
  500: '#009DB1',
  // "Official Planet Teal" / main
  600: '#018899',
  800: '#017382',
  900: '#025E6A',
  A100: 'rgba(0,157,177,0.18)',
  A200: 'rgba(0,157,177,0.36)',
  A300: 'rgba(0,157,177,0.72)'
};
export var PLANET_BLUE = TEAL[500];
export var PINK = {
  50: '#FEE6F0',
  100: '#FC99C2',
  200: '#F94D93',
  500: '#F70065',
  // main
  600: '#D60058',
  800: '#B5004A',
  900: '#94003D',
  A100: 'rgba(247,0,101,0.18)',
  A200: 'rgba(247,0,101,0.36)',
  A300: 'rgba(247,0,101,0.72)'
};
export var GREY = {
  50: '#ffffff',
  100: '#f0f2f2',
  200: '#dbdfe0',
  300: '#bdc5c6',
  400: '#99a5a7',
  500: '#738486',
  600: '#4c6265',
  // text secondary
  700: '#264044',
  800: '#122f33',
  900: '#001f23',
  // text primary
  A100: darken('#bdc5c6', 0.08),
  A200: '#99a5a7',
  A400: '#4c6265',
  A700: '#264044'
};
export var BLUE = {
  50: '#e7f7fd',
  200: '#8AD9F7',
  400: '#2AB8F0',
  500: '#10b1ef',
  700: '#0d7ba7',
  800: '#07465F'
};
export var GREEN = {
  50: '#e9fbee',
  200: '#8be6a9',
  400: '#2ED164',
  500: '#18cc53',
  700: '#108f3a',
  800: '#065321'
};
export var INDIGO = {
  50: '#edeeff',
  200: '#A5ACFF',
  400: '#5C6AFF',
  500: '#4a59ff',
  700: '#353eb4',
  800: '#1E2466'
};
export var ORANGE = {
  50: '#fef2e7',
  200: '#FBBF83',
  400: '#F68B21',
  500: '#f57e09',
  700: '#ad5803',
  800: '#623202'
};
export var PURPLE = {
  50: '#f6e9fc',
  200: '#D48FF1',
  400: '#B235E6',
  500: '#a91fe3',
  700: '#76169f',
  800: '#440C5C'
};
export var RED = {
  50: '#ffe8e7',
  200: '#F98E85',
  400: '#F33523',
  500: '#f21d09',
  700: '#aa1306',
  800: '#610D04'
};
export var YELLOW = {
  50: '#fffbe7',
  200: '#FDE987',
  400: '#FBD727',
  500: '#fad40f',
  700: '#af940c',
  800: '#645406'
};

// better 4.5:1 contrast with most colors
export var LIGHT_PRIMARY_TEXT = '#041213';
export default {
  WHITE: WHITE,
  TEAL: TEAL,
  ACCENT: ACCENT,
  PLANET_BLUE: PLANET_BLUE,
  PINK: PINK,
  GREY: GREY,
  BLUE: BLUE,
  GREEN: GREEN,
  INDIGO: INDIGO,
  ORANGE: ORANGE,
  PURPLE: PURPLE,
  RED: RED,
  YELLOW: YELLOW,
  LIGHT_PRIMARY_TEXT: LIGHT_PRIMARY_TEXT
};